import { useEffect } from 'react';

import { DefaultValues, useForm, Path } from 'react-hook-form';

interface IUseHandleFormProps<T extends object> {
    onSubmit: (data: T) => void;
    resetEnable?: boolean;
    defaultValues?: DefaultValues<T>;
    mode?: 'onBlur' | 'onChange' | 'onSubmit' | 'onTouched' | 'all';
}

export const useHandleForm = <T extends object>({
    onSubmit,
    defaultValues,
    resetEnable = true,
    mode = 'onSubmit',
}: IUseHandleFormProps<T>) => {
    const {
        control,
        handleSubmit,
        formState: { errors, isSubmitting, isDirty, isValid },
        clearErrors,
        reset,
        setFocus,
        setValue,
        setError,
        watch,
    } = useForm<T>({ shouldFocusError: false, defaultValues, mode });

    useEffect(() => {
        const keys = Object.keys(errors);
        if (keys.length > 0) {
            setFocus(keys[0] as Path<T>);
        }
    }, [errors, setFocus]);

    return {
        control,
        handleSubmit: handleSubmit((data: T) => {
            onSubmit(data);
            if (resetEnable) {
                reset();
            }
        }),
        errors,
        isSubmitting,
        isDirty,
        isValid,
        reset,
        setValue,
        setError,
        clearErrors,
        watch,
    };
};
